// extracted by mini-css-extract-plugin
export default {"root":"PlasmicResetPasswordButton_root__dXjX9","text":"PlasmicResetPasswordButton_text__x2f5Q"};